"use client";

import { type PackageType } from "@/lib/revenuecat/config";

const BILLING_OPTIONS: Array<{ label: string; value: PackageType }> = [
  { label: "Annual", value: "annual" },
  { label: "Monthly", value: "monthly" },
  { label: "Weekly", value: "weekly" },
];

export function BillingFrequencyToggle({
  disabled = false,
  onChange,
  value,
}: {
  disabled?: boolean;
  onChange: (value: PackageType) => void;
  value: PackageType;
}) {
  return (
    <div
      aria-label="Billing frequency"
      className="grid grid-cols-3 rounded-lg border border-white/10 bg-[#0F0F14] p-1"
      role="radiogroup"
    >
      {BILLING_OPTIONS.map((option) => (
        <button
          aria-checked={value === option.value}
          className={`min-h-11 rounded-md px-2 py-2 text-xs font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FD954F] md:text-sm ${
            value === option.value
              ? "bg-white/10 text-white ring-1 ring-inset ring-white/10"
              : "text-[#AEAEB2] hover:bg-white/5 hover:text-white"
          }`}
          disabled={disabled}
          key={option.value}
          onClick={() => onChange(option.value)}
          role="radio"
          type="button"
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
